/**
 * A project status broadcast that changes which projects a member may keep open.
 *
 * Archiving removes the project from every active view, so other members' open boards must drop it
 * without a reload; any other status (for example a restore to active) refreshes the project
 * catalog so a restored project is offered again. Only messages whose updatedFields name the status
 * count: renames, client, settings and creation broadcasts repeat the unchanged status, and treating
 * those as access changes would reload every member's session and project catalog for a rename.
 */
export type ProjectStatusAccessDetail = {
  type: 'project_access_updated';
  projectId: string;
  action: 'project-archived' | 'project-status-changed';
  status: string;
};

export function projectStatusAccessDetail(
  projectId: string | undefined,
  message: Record<string, unknown>,
): ProjectStatusAccessDetail | null {
  const status = message.status;
  const updatedFields = message.updatedFields;
  if (!projectId || typeof status !== 'string' || !status) return null;
  if (!Array.isArray(updatedFields) || !updatedFields.includes('status')) return null;
  return {
    type: 'project_access_updated',
    projectId,
    action: status === 'archived' ? 'project-archived' : 'project-status-changed',
    status,
  };
}
